import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getQuickLinks = async (appId: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/quicklinks?appId=${appId}`
  );

  return data;
};

export const createQuickLink = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/quicklinks?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateQuickLink = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/quicklinks?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteQuickLink = async (quicklinkId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/quicklinks/${quicklinkId}`
  );

  return data;
};
